import type { ScreenerColumn } from "epsm-api-types/models";
import { useEffect, useMemo, useState } from "react";
import { ScreenerColumnService } from "@/components/widgets/Screener/services/ScreenerColumnService";

export const useScreenerColumns = () => {
	const [columns, setColumns] = useState<ScreenerColumn[]>([]);

	useEffect(() => {
		ScreenerColumnService.create()
			.getData()
			.then((cols) => setColumns(cols?.data || []))
			.catch(() => setColumns([]));
	}, []);

	const columnsMap = useMemo(
		() => new Map(columns.map((col) => [col.name, col])),
		[columns],
	);

	return {
		columns,
		getColumn: (name: string) => columnsMap.get(name),
		getColumnValueAndClassName: (
			name: string,
			value?: string | number | null,
		) => {
			const col = columnsMap.get(name);
			const displayValue =
				col?.options?.[value as keyof typeof col.options] ?? value;

			return {
				value: displayValue,
				className: col?.fncClassName?.(displayValue as unknown as number) ?? "",
			};
		},
	};
};
